import { FormattedMessage } from 'react-intl';

import { ROUTES } from '@arrived/common';
import { useGetPrimaryAccountQuery } from '@arrived/queries';

import { InaccessiblePage } from '../InaccessiblePage';
import { StaticErrorView } from '../StaticErrorView';

import { useIsMobile } from '../hooks';
import { PortfolioPrivacyContextProvider } from './common';
import { PortfolioDesktop } from './desktop';
import { PortfolioMobile } from './mobile';

export interface PortfolioProps {
  // TODO: Some refactoring needs to be done to remove this. Either this component needs to go into web-app or the
  //  verification stepper needs to move to components. More than likely this should just be moved to web-app since
  //  we won't use it in other applications, although a lot of other components unfortunately rely on some of the
  //  components nested in here so that work is for another time.
  topOffset?: number;
}

export const Portfolio = ({ topOffset }: PortfolioProps) => {
  const accountState = useGetPrimaryAccountQuery();
  const isMobile = useIsMobile();

  if (accountState.isError) {
    if (accountState.error?.status === 404) {
      return (
        <InaccessiblePage
          buttonText={<FormattedMessage id="complete-account-setup" defaultMessage="Complete Account Setup" />}
          destination={ROUTES.accounts.createAccount}
          text={
            <FormattedMessage
              id="finish-setting-up-account"
              defaultMessage="It looks like you don’t own any properties yet! If you’d like to start investing with us, please finish setting up your account."
            />
          }
        />
      );
    }

    return <StaticErrorView error={accountState.error} />;
  }

  return (
    <PortfolioPrivacyContextProvider>
      {isMobile ? (
        <PortfolioMobile accountId={accountState.data?.id} topOffset={topOffset} />
      ) : (
        <PortfolioDesktop accountId={accountState.data?.id} topOffset={topOffset} />
      )}
    </PortfolioPrivacyContextProvider>
  );
};
